/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FilterPaidEventDto { 
    /**
     * Search by name event
     */
    title?: string;
    dateFilter?: FilterPaidEventDto.DateFilterEnum;
    fromDate?: string;
    toDate?: string;
    /**
     * Filter by sport ids
     */
    sportIds?: Array<string>;
    /**
     * Minimum total revenue
     */
    priceFrom?: number;
    /**
     * Maximum total revenue
     */
    priceTo?: number;
    payoutStatuses?: Array<FilterPaidEventDto.PayoutStatusesEnum>;
    timezone?: string;
    sortBy?: string;
    sortOrder?: FilterPaidEventDto.SortOrderEnum;
    page?: number;
    limit?: number;
}
export namespace FilterPaidEventDto {
    export type DateFilterEnum = 'TODAY' | 'YESTERDAY' | 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'CUSTOM';
    export const DateFilterEnum = {
        Today: 'TODAY' as DateFilterEnum,
        Yesterday: 'YESTERDAY' as DateFilterEnum,
        Last7Days: 'LAST_7_DAYS' as DateFilterEnum,
        Last30Days: 'LAST_30_DAYS' as DateFilterEnum,
        Custom: 'CUSTOM' as DateFilterEnum
    };
    export type PayoutStatusesEnum = 'AVAILABLE' | 'IN_ESCROW' | 'TRANSFERRED' | 'CANCELLED' | 'INCOMING' | 'PENDING' | 'PENDING_PAYOUT';
    export const PayoutStatusesEnum = {
        Available: 'AVAILABLE' as PayoutStatusesEnum,
        InEscrow: 'IN_ESCROW' as PayoutStatusesEnum,
        Transferred: 'TRANSFERRED' as PayoutStatusesEnum,
        Cancelled: 'CANCELLED' as PayoutStatusesEnum,
        Incoming: 'INCOMING' as PayoutStatusesEnum,
        Pending: 'PENDING' as PayoutStatusesEnum,
        PendingPayout: 'PENDING_PAYOUT' as PayoutStatusesEnum
    };
    export type SortOrderEnum = 'asc' | 'desc';
    export const SortOrderEnum = {
        Asc: 'asc' as SortOrderEnum,
        Desc: 'desc' as SortOrderEnum
    };
}


